import { Box, Dialog, DialogContent, Fade, Modal, Skeleton, Stack } from '@mui/material'
import { AlreadyAccount } from 'Components/Elements/SignUp/SignUp'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import { observer } from 'mobx-react-lite'
import { Suspense, useEffect, useMemo, useState } from 'react'
import Login from '../../Elements/Login/Login'
import { lazy } from 'react'
import pMinDelay from 'p-min-delay'
import StoreCheckout from 'GlobalStores/Checkout/StoreCheckout'
import styled from '@emotion/styled'
import MoneyBack from 'Components/Elements/Checkout/MoneyBack'
import { DefaultButton } from 'Components/Elements/Forms'
import { useSizeWindow } from 'Helpers/GlobalHelpers'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import PaymentForm from 'Components/Elements/Checkout/ShippingAddressForm/Country/Morocco/PaymentForm'
import { isSomething } from 'Utils/Utils'
import Checkout from 'GlobalStores/Checkout/Country/Checkout'
import storeFormat from 'GlobalStores/Format/StoreFormat'
import { get } from 'lodash'

import { useLocation, useNavigate } from 'react-router-dom'
import StoreLoader from 'GlobalStores/Cores/Elements/StoreLoader'
import { runInAction, toJS } from 'mobx'
import storeCheckout from 'GlobalStores/Checkout/StoreCheckout'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import PaymentHydraForm from 'Components/Elements/Checkout/ShippingAddressForm/Country/PaymentHydraForm'
import ReCaptchaV3 from 'Components/Elements/ReCaptcha/ReCaptchaV3'
import { storeElement } from 'GlobalStores/StoreElement'
import { FormatAPIs } from 'Services/FeelGreat/FormatAPIs'
import DuplicatedOrder from 'Components/Elements/DuplicatedOrder/DuplicatedOrder'

const PreSummaryBoxLazyLoad = lazy(() => pMinDelay(import('../../Elements/Checkout/PreSummaryBox'), 0))
const MoroccoCreateAccountWithShippingLazyLoad = lazy(() =>
    pMinDelay(import('../../Elements/Checkout/ShippingAddressForm/Country/Morocco/MoroccoCreateAccountWithShipping'), 0)
)
const MoroccoShippingAddressLazyLoad = lazy(() => pMinDelay(import('../../Elements/Checkout/ShippingAddressForm/Country/Morocco/MoroccoShippingAddress'), 0))

const MoroccoPaymentLazyLoad = lazy(() => pMinDelay(import('../../Elements/Checkout/ShippingAddressForm/Country/Morocco/MoroccoPayment'), 0))

const MoroccoCheckoutTheme = observer(({ Sections, step, onPlaceOrder, openLoginModal, setOpenLoginModal }) => {
    const translate = useTranslate()
    const { width } = useSizeWindow()
    const [dataPayment, setDataPayment] = useState({})
    const [loading, setLoading] = useState(false)
    const [sectionReady, setSectionReady] = useState(false)
    const [openDuplicatedModal, setOpenDuplicatedModal] = useState(false)
    const [duplicatedData, setDuplicatedData] = useState({
        paymentId: '',
        dateAndTime: '',
        totalPrice: '',
        currency: '',
        is_duplicate: false
    })

    const location = useLocation()

    const qs = useMemo(() => new URLSearchParams(window.location.search), [])

    const shippingPaymentOption = StoreCheckout.GetShippingPaymentOption()

    const [dataRedirectToPayment, setDataRedirectToPayment] = useState()

    const navigate = useNavigate()

    useEffect(() => {
        setLoading(false)
    }, [])

    const ThemeSections = step => {
        switch (step) {
            case 'payment':
                return <MoroccoPaymentLazyLoad onPlaceOrder={onPlaceOrder} sectionReady={setSectionReady} />
            case 'create-account':
                return <MoroccoCreateAccountWithShippingLazyLoad sectionReady={setSectionReady} />
            default:
                return <MoroccoShippingAddressLazyLoad sectionReady={setSectionReady} />
        }
    }

    const submitRedirectPayment = async () => {
        setLoading(true)

        if (StoreCheckout.CheckOutInstance().Instance().PaymentGateway === 'hydra3ds') {
            const checkout = new Checkout()
            let items = []
            storeFormat.GetFormatData('formatProducts').map(item => {
                items.push({
                    item_id: item.item_code,
                    item_name: item.item_name.english + ' ' + item.item_name.english,
                    price: item.baStatus === 'C' ? item.retail_price_x_qty.value : item.price_x_qty.value
                })
            })
            const termsFromOrderCal = get(StoreCheckout.orderCalcData, 'terms', null)

            let totalPrice = StoreCheckout.TotalPrice()
            if (termsFromOrderCal) {
                totalPrice = get(termsFromOrderCal, 'total', StoreCheckout.TotalPrice())
            }

            try {
                const response = await checkout.SubmitPayment(
                    StoreCheckout.GetUuid(),
                    storeFormat.GetDetailPage(),
                    {},
                    StoreCheckout.GetBillingAddressForm(),
                    items,
                    {
                        shippingPaymentOption: StoreCheckout.GetShippingPaymentOption(),
                        totalPrice: totalPrice
                    }
                )
                if (StoreCheckout.GetShippingPaymentOption()?.id === 2) {
                    // cash on delivery
                    storeCheckout.ClearCart()
                    navigate(`/payment-response/success?payment_id=${response.payment_id}`)
                } else {
                    // credit card
                    console.log('response.orderData', toJS(response.orderData))
                    if (response.orderData.transactions.items.length > 1) {
                        console.log('case AR + credit card')
                        const dataPrepareToForm = response.orderData.transactions.items.find(item => item.method === 'CreditCard')
                        if (dataPrepareToForm) {
                            setDataRedirectToPayment({
                                formMethod: get(dataPrepareToForm, 'methodDetails.iouReceipt.method'),
                                formAction: get(dataPrepareToForm, 'methodDetails.iouReceipt.url'),
                                formData: get(dataPrepareToForm, 'methodDetails.iouReceipt.data')
                            })
                        }

                        // case transaction AR + credit card
                    } else {
                        const transactionCreditCard = response.orderData.transactions.items.find(item => item.method === 'CreditCard')
                        if (transactionCreditCard) {
                            console.log('case only credit card')
                            setDataRedirectToPayment({
                                formMethod: get(response.orderData, 'transactions.items[0].methodDetails.iouReceipt.method'),
                                formAction: get(response.orderData, 'transactions.items[0].methodDetails.iouReceipt.url'),
                                formData: get(response.orderData, 'transactions.items[0].methodDetails.iouReceipt.data')
                            })
                            // case only credit card
                        } else {
                            console.log('case only AR')
                            navigate(`/payment-response/success?payment_id=${response.payment_id}`)
                            // case only AR
                        }

                    }
                }
            } catch (e) {
                console.log('error', e)
                setLoading(false)
            }
        } else {
            // if (StoreCheckout.CheckOutInstance().PaymentGateway === 'hydra3ds') {
            //     console.log('submit payment')
            // } else {
            //     const hostname = window.location.origin
            //     const postbackUrl = {
            //         success: `{{hostname}}/{{country}}/payment-response/success`,
            //         error: `{{hostname}}/{{country}}/payment-response/failed`
            //     }
            //     const successUrl = postbackUrl.success.replace('{{hostname}}', hostname).replace('{{country}}', StoreCountry.CountryLowerCase())
            //     const errorUrl = postbackUrl.error.replace('{{hostname}}', hostname).replace('{{country}}', StoreCountry.CountryLowerCase())
            //     const query = new URLSearchParams(document.location.search)
            //     const data = {
            //         uuid: query.get('uuid'),
            //         gateway_success_url: successUrl,
            //         gateway_error_url: errorUrl,
            //         gateway_name: 'CMI',
            //         source_path: window.location.href,
            //         type: 'feelGreat'
            //     }
            //     if (StoreAuth.isAuthorized) {
            //         data.ba_id = StoreAuth.GetId()
            //         data.token = StoreAuth.GetToken()
            //     }
            //     // StoreCheckout.setPaymentCybersourceData(data)
            //     // const result = await FeelGreatAPI.CreatePaymentDataForHostedGateway(data)
            //     // Mockup is real
            //     setDataPayment({
            //         storeKey: 'Umorocco_a2021',
            //         clientid: '600000697',
            //         actionUrl: 'https://testpayment.cmi.co.ma/fim/est3Dgate',
            //         callbackUrl: 'https://member-calls2-dev.unicity.com/hot/payment_router/CMI/forward/MAR',
            //         storetype: '3d_pay_hosting',
            //         trantype: 'PreAuth',
            //         amount: '1890.00',
            //         currency: '504',
            //         oid: '970900000135',
            //         okUrl: successUrl,
            //         failUrl: errorUrl,
            //         lang: 'en',
            //         hashAlgorithm: 'ver3',
            //         tel: '1234167890',
            //         email: 'test@abcedfg.com',
            //         BillToCompany: 'billToCompany',
            //         BillToName: 'aaa bbb',
            //         hash: 'MWRkM2RkOGMyZTU1MzQzZDNjZDc3MWYxYzQ0ZjU0NGZhYWNmZjJjMjExODNlZjRhMTVlN2ZjNDNjMDAyMTY3OTE5NDE1NWY0YmU3ZGJiYTM0MDJiZjM5MjAzOWQwMzczZDczODM5ZGY3YmZlNmYzM2E3OWUyZjA4ZWY4YTY5ZjM=',
            //         rnd: 'BqLjs6oBjvDTrH2',
            //         hashPlaintext:
            //             '1890.00|billToCompany|aaa bbb|https://member-calls2-dev.unicity.com/hot/payment_router/CMI/forward/MAR|600000697|504|test@abcedfg.com|http://localhost:5173/#fail|ver3|en|http://localhost:5173/#success|BqLjs6oBjvDTrH2|3d_pay_hosting|PreAuth|Umorocco_a2021'
            //     })
            // }
        }
    }

    const closeDuplicateModal = () => {
        setOpenDuplicatedModal(false)
        runInAction(() => {
            storeElement.showCardFrontDrop = false
        })
    }

    const confirmPlaceOrder = async () => {
        setOpenDuplicatedModal(false)
        runInAction(() => {
            storeCheckout.paymentErrors = []
            storeElement.showCardFrontDrop = true
        })
        await submitRedirectPayment()
    }

    const onClickPlaceOrder = async () => {
        const pathname = location.pathname
        const BreadcrumbStep = storeCheckout.CheckOutInstance().GetBreadcrumbOption()
        const paymentStep = BreadcrumbStep.findIndex(item => item.link === pathname)
        const lastStep = paymentStep === BreadcrumbStep.length - 1

        if (lastStep) {
            const responseDuplicateOrder = await checkDuplicateOrder()

            if (responseDuplicateOrder.isDuplicate) {
                return
            } else {
                await submitRedirectPayment()
            }
        } else {
            await submitRedirectPayment()
        }
    }

    const checkDuplicateOrder = async () => {
        try {
            runInAction(() => {
                storeCheckout.paymentErrors = []
                storeElement.showCardFrontDrop = true
            })
            const checkDuplicateOrder = await FormatAPIs.checkDuplicateOrder({
                countryCode3Alpha: StoreCountry.Country3(),
                uuid: storeCheckout.GetUuid() || qs.get('uuid')
            })

            if (checkDuplicateOrder.data.is_duplicate === true) {
                setDuplicatedData({
                    paymentId: checkDuplicateOrder.data.payments_id,
                    dateAndTime: checkDuplicateOrder.data.date_time,
                    totalPrice: checkDuplicateOrder.data.total_price,
                    is_duplicate: true,
                    currency: checkDuplicateOrder.data.currency || StoreCountry.GetCurrencyCode()
                })
                setOpenDuplicatedModal(true)
            } 

            return {
                isDuplicate: checkDuplicateOrder.data.is_duplicate
            }
        } catch (e) {
            console.log('error', e)
            closeDuplicateModal()
        }
    }

    const extendPlaceOrder = () => {
        return (
            <Stack alignItems={'center'}>
                <DefaultButton
                    titleText={translate('proceed_to_payment')}
                    disabled={loading || shippingPaymentOption === null}
                    onClick={onClickPlaceOrder}
                    width={width > 700 ? '340px' : '100%'}
                    isloading={loading.toString()}
                    style={{ marginTop: '25px', fontSize: '18px' }}
                />
                <MoneyBack />
            </Stack>
        )
    }

    useEffect(() => {
        if (StoreLoader.IsFormatApiLoading() === true) {
            setSectionReady(false)
        }
    }, [StoreLoader.IsFormatApiLoading()])

    return (
        <MarStackStyled stepPaymentOrReview={step}>
            <Suspense fallback={<PageSkeletonFormElement />}>
                <Stack>{ThemeSections(step)}</Stack>
            </Suspense>

            {/* {!sectionReady && <PageSkeletonFormElement />} */}

            <Stack width={width > 1200 ? '380px' : 'auto'}>
                {!sectionReady && StoreLoader.IsFormatApiLoading() ? (
                    <PageSkeletonSummaryElement />
                ) : (
                    <Suspense fallback={<PageSkeletonSummaryElement />}>
                        <PreSummaryBoxLazyLoad
                            step={step}
                            edit={false}
                            isReady={StoreCheckout.isReadyToPlaceOrder}
                            onPlaceOrder={onPlaceOrder}
                            extendPlaceOrder={extendPlaceOrder}
                        />
                    </Suspense>
                )}
            </Stack>

            {step === 'create-account' && (
                <>
                    {StoreLoader.IsFormatApiLoading() ? (
                        <PageSkeletonAccountElement />
                    ) : (
                        <DesktopAlreadyAccount>
                            <AlreadyAccount setOpenLoginModal={setOpenLoginModal} />
                        </DesktopAlreadyAccount>
                    )}
                    <Modal
                        open={openLoginModal}
                        onClose={() => {
                            if (StoreAuth.loadingLogin) return
                            setOpenLoginModal(false)
                        }}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description">
                        <Fade in={openLoginModal}>
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 'calc(50% - 40px)',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    padding: '0px'
                                }}>
                                <Login showFooter={false} setOpenLoginModal={setOpenLoginModal} />
                            </Box>
                        </Fade>
                    </Modal>
                </>
            )}

            {step === 'payment' && (
                <DialogDuplicatedStyled open={openDuplicatedModal}>
                    <DialogContent
                        sx={{
                            padding: {
                                xs: '32px 24px',
                                md: '64px 93px'
                            }
                        }}>
                        <DuplicatedOrder confirmPlaceOrder={confirmPlaceOrder} setOpenModal={closeDuplicateModal} {...duplicatedData} />
                    </DialogContent>
                </DialogDuplicatedStyled>
            )}
            {isSomething(dataPayment) && (
                <div style={{ display: 'none' }}>
                    <PaymentForm dataPayment={dataPayment} />
                </div>
            )}
            {dataRedirectToPayment && (
                <div style={{ display: 'inherit' }}>
                    <PaymentHydraForm dataPayment={dataRedirectToPayment} />
                </div>
            )}
        </MarStackStyled>
    )
})

const StackStyled = styled.div`
    padding-top: 40px;
    padding-bottom: 40px;
    min-height: 50vh;
    display: flex;
    flex-direction: ${props => (props.stepPaymentOrReview ? 'column' : 'column-reverse')};
    justify-content: ${props => (props.stepPaymentOrReview ? 'flex-start' : 'flex-end')};
    gap: 20px;

    @media screen and (min-width: 399px) {
        padding-top: 40px;
    }

    @media screen and (min-width: 600px) {
        padding-top: 60px;
    }

    @media screen and (min-width: 1200px) {
        display: grid;
        grid-template-columns: 770px 370px;
        gap: 22px;
        padding-top: 40px;
    }
`

const MarStackStyled = styled(StackStyled)`
    flex-direction: ${props => (props.stepPaymentOrReview === 'payment' ? 'column' : 'column-reverse')};
    justify-content: ${props => (props.stepPaymentOrReview ? 'flex-start' : 'flex-end')};

    @media screen and (min-width: 768px) {
        padding-top: 40px;
        gap: 20px;
    }
`

const DesktopAlreadyAccount = styled('div')`
    display: block;
    @media screen and (min-width: 1200px) {
        display: none;
    }
`

const DialogDuplicatedStyled = styled(Dialog)`
    .MuiDialog-paper {
        border-radius: 12px;
        box-shadow: none;
        @media screen and (min-width: 768px) {
            width: 100%;
            max-width: 650px;
        }
    }
`

const PageSkeletonFormElement = observer(props => {
    return (
        <Stack>
            <Stack mb="20px">
                <Skeleton variant="rounded" width={'100%'} height={'340px'} sx={{ margin: '0', borderRadius: '12px' }} />
            </Stack>
            <Stack mb="20px">
                <Skeleton variant="rounded" width={'100%'} height={'400px'} sx={{ margin: '0', borderRadius: '12px' }} />
            </Stack>
            <Stack>
                <Skeleton variant="rounded" width={'100%'} height={'400px'} sx={{ margin: '0', borderRadius: '12px' }} />
            </Stack>
        </Stack>
    )
})

const PageSkeletonAccountElement = observer(props => {
    return (
        <Stack
            sx={{
                display: 'block',
                '@media screen and (min-width: 1200px)': {
                    display: 'none'
                }
            }}>
            <Skeleton variant="rounded" width={'100%'} height={'64px'} sx={{ margin: '0', borderRadius: '12px' }} />
        </Stack>
    )
})

const PageSkeletonSummaryElement = observer(props => {
    return (
        <Stack>
            <Skeleton
                variant="rounded"
                width={'100%'}
                sx={{
                    margin: '0',
                    borderRadius: '12px',
                    height: '108px',
                    '@media screen and (min-width: 1200px)': {
                        height: '370px'
                    }
                }}
            />
        </Stack>
    )
})

export default MoroccoCheckoutTheme
